<header class="statement-header">
  <h2 class="statement-title">{{ view().title }}</h2>

  <div class="statement-actions">
    <button
      type="button"
      class="btn statement-verify"
      [attr.aria-keyshortcuts]="checking() ? 'Shift+F5' : 'Control+Shift+Enter'"
      [appTooltip]="checking() ? 'Parar a correção' : 'Testar o programa com as entradas do exercício'"
      [appTooltipShortcut]="checking() ? 'Shift+F5' : 'Ctrl+Shift+Enter'"
      [class.btn-primary]="!checking()"
      [attr.aria-disabled]="(!checking() && busy()) || null"
      (click)="onVerifyClick()"
    >
      @if (checking()) {
        <svg-icon src="assets/mdi/square-rounded-outline.svg" class="icon-red" aria-hidden="true" />
        Parar
      } @else {
        <svg-icon src="assets/mdi/clipboard-check-outline.svg" aria-hidden="true" />
        Verificar
      }
    </button>

    @if (copy()) {
      <button
        type="button"
        class="btn btn-icon-only"
        aria-label="Usar no meu exercício"
        appTooltip="Usar no meu exercício"
        [attr.aria-disabled]="busy() || null"
        (click)="!busy() && adopt.emit()"
      >
        <svg-icon src="assets/mdi/file-import-outline.svg" aria-hidden="true" />
      </button>
    } @else {
      <button
        type="button"
        class="btn"
        appTooltip="Voltar ao código inicial do exercício"
        [attr.aria-disabled]="busy() || null"
        (click)="!busy() && restart.emit()"
      >
        <svg-icon src="assets/mdi/restore.svg" aria-hidden="true" />
        Recomeçar
      </button>
    }
  </div>

  <p class="statement-meta">
    <span class="statement-difficulty">
      <svg-icon aria-hidden="true" [src]="view().difficultyIcon" />
      {{ view().difficulty }}
    </span>
    @if (done()) {
      <span class="statement-done">
        <svg-icon src="assets/mdi/check-circle.svg" class="icon-green" aria-hidden="true" />
        Concluído
      </span>
    }
  </p>
  @if (approvedChanged()) {
    <p class="statement-note">
      <svg-icon src="assets/mdi/information-outline.svg" class="icon-blue" aria-hidden="true" />
      <span>
        O código mudou desde que passou.
        <button
          type="button"
          class="link-button"
          [attr.aria-disabled]="busy() || null"
          (click)="!busy() && restoreApproved.emit()"
        >
          Reverter alterações
        </button>
      </span>
    </p>
  }
  @if (copy()) {
    <p class="statement-note">
      <svg-icon src="assets/mdi/information-outline.svg" class="icon-blue" aria-hidden="true" />
      Aberto de um arquivo ou link: o Verificar não conta para o seu progresso.
    </p>
  }
</header>

<div class="statement-body" role="region" aria-label="Enunciado" tabindex="0">
  @if (statement.hasValue()) {
    <div class="markdown exercise-markdown" [innerHTML]="statement.value()"></div>
    @if (view().attribution; as attribution) {
      <p class="statement-attribution">{{ attribution }}</p>
    }
  } @else if (statement.error()) {
    <div class="statement-error" role="alert">
      <p>Não foi possível mostrar o enunciado.</p>
      <button type="button" class="btn" (click)="statement.reload()">
        <svg-icon src="assets/mdi/refresh.svg" aria-hidden="true" />
        Tentar de novo
      </button>
    </div>
  }

  <h3 class="examples-heading">{{ view().examples.length === 1 ? "Exemplo" : "Exemplos" }}</h3>

  @for (example of view().examples; track $index) {
    <section class="example">
      <h4 class="example-title">
        Exemplo {{ $index + 1 }}
        @if (example.description) {
          <span class="example-description">({{ example.description }})</span>
        }
      </h4>

      <dl>
        @if (example.showsInputs) {
          <dt>Entrada</dt>
          <dd>
            @if (example.inputs.length > 0) {
              <pre>{{ example.inputs.join("\n") }}</pre>
            } @else {
              <span class="muted">nenhuma</span>
            }
          </dd>
        }

        @if (example.output !== undefined) {
          <dt>Saída esperada</dt>
          <dd>
            @if (example.output.trim()) {
              <pre>{{ example.output }}</pre>
            } @else {
              <span class="muted">nenhuma</span>
            }
          </dd>
        }

        @for (check of example.checks; track $index) {
          @if (check.target === "function") {
            <dt>
              Retorno de <code>{{ check.call }}</code>
              @if (check.description) {
                <span class="example-description">({{ check.description }})</span>
              }
            </dt>
            <dd>
              <code [appPortugol]="check.returned | exerciseValue"></code>
            </dd>
          } @else {
            <dt>
              @if (check.rule === "igual") {
                Valores escritos
              } @else if (example.inputs.length > 0) {
                Valores que precisam ser escritos depois da última leitura, nesta ordem
              } @else {
                Valores que precisam ser escritos, nesta ordem
              }
              @if (check.description) {
                <span class="example-description">({{ check.description }})</span>
              }
            </dt>
            <dd>
              <ul class="values">
                @for (value of check.values; track $index) {
                  <li>
                    <code [appPortugol]="value | exerciseValue"></code>
                  </li>
                }
              </ul>
            </dd>
          }
        }
      </dl>
    </section>
  }
</div>
